import { render, staticRenderFns } from "./ExchangeBidForm.vue?vue&type=template&id=146b7997&scoped=true&lang=pug&"
import script from "./ExchangeBidForm.vue?vue&type=script&lang=js&"
export * from "./ExchangeBidForm.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeBidForm.vue?vue&type=style&index=0&id=146b7997&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146b7997",
  null
  
)

export default component.exports